export default __webpack_public_path__ + "static/media/writing-competition-logo.18658bd9.png";